// components/ProjectTable.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Tables.css";

const ProjectTable = () => {
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/projects`)
      .then(res => {
        const data = res.data.projects || [];
        setProjects(data)})
      .catch(err => console.error(err));
  }, []);

  const filtered = projects.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  // Handle Delete Modal

  const openDeleteModal = (project) => {
    setSelectedProject(project);
    setShowDeleteModal(true);
  };

  const deleteProject = async () => {
    if (!selectedProject) return;

    try {
      setIsDeleting(true);

      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/projects/${selectedProject.id}`
      );

      setShowDeleteModal(false);
      setSelectedProject(null);
      setIsDeleting(false);

      // Refresh project list
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/projects`);
      const data = res.data.projects || [];
      setProjects(data);
    } catch (error) {
      console.error("Error deleting project:", error);
      setIsDeleting(false);
    }
  };

  return (
    <div className="table-container">
      <h3>Projects</h3>
      <input
        type="text"
        placeholder="Search by project name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <table>
        <thead>
          <tr>
            <th>Project ID</th>
            <th>Project Name</th>
            <th>Live URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((proj) => (
            <tr key={proj.id}>
              <td>{proj.id}</td>
              <td>{proj.name}</td>
              <td>
                <a 
                   href={`/map/${proj.id}`} 
                   target="_blank" 
                   rel="noreferrer"
                >
                  View Map
                </a>
              </td>

              <td>
                <button
                  className="delete-button"
                  onClick={() => openDeleteModal(proj)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Delete Confirmation Modal */ }
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>Confirm Deletion</h4>
            <p>Are you sure you want to delete the project ""
              <strong>{selectedProject?.name}</strong> and all its plots?              
            </p>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>

              <button
                className="confirm-delete-btn"
                onClick={deleteProject}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectTable;
